import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { MemberLayout } from "../components/MemberLayout"
import { CourseOverview } from "@/components/course/CourseOverview"

export default function CourseShow({ currentUser, course, lessons = [], progress = {} }) {
  return (
    <MemberLayout currentUser={currentUser}>
      <Head title={`${course.title} - Kingdom Factor`} />

      <div className="space-y-6 max-w-3xl mx-auto">
        {/* Back link */}
        <Link
          href="/app/member/courses"
          className="inline-flex items-center gap-1.5 text-sm text-zinc-600 hover:text-kf-red transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Courses
        </Link>

        <CourseOverview
          course={course}
          lessons={lessons}
          progress={progress}
          lessonHref={(lesson) => `/app/member/courses/${course.id}/lessons/${lesson.id}`}
        />
      </div>
    </MemberLayout>
  )
}
